import type { AppLanguage } from './config';

const THOUSANDS_SEPARATORS: Record<AppLanguage, string> = {
    en: ',',
    de: '.',
    fr: ' ',
    es: '.',
    it: '.',
    pt: '.'
};

const THOUSANDS_GROUP = /\B(?=(\d{3})+(?!\d))/g;

export function formatInteger(value: number, language: AppLanguage): string {
    return String(Math.round(value)).replace(THOUSANDS_GROUP, THOUSANDS_SEPARATORS[language]);
}
